import K from "@babel/runtime/helpers/esm/slicedToArray";
import M from "@babel/runtime/helpers/esm/extends";
import J from "@babel/runtime/helpers/esm/objectWithoutProperties";
import h from "@babel/runtime/helpers/esm/objectSpread2";
import Q from "@babel/runtime/helpers/esm/classCallCheck";
import V from "@babel/runtime/helpers/esm/createClass";
import A from "@babel/runtime/helpers/esm/assertThisInitialized";
import y from "@babel/runtime/helpers/esm/get";
import C from "@babel/runtime/helpers/esm/getPrototypeOf";
import U from "@babel/runtime/helpers/esm/inherits";
import X from "@babel/runtime/helpers/esm/createSuper";
import b from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as F } from "@semcore/utils/lib/core/index";
import q, { assignProps as S, sstyled as R } from "@semcore/core";
import g from "react";
import Y from "classnames";
import v from "@semcore/dropdown-menu";
import w, { enhance as ee, selectedIndexContext as te, AbstractDropdown as re } from "@semcore/dropdown";
import { ButtonTrigger as I } from "@semcore/base-trigger";
import ne from "@semcore/divider";
import ie, { isAdvanceMode as k } from "@semcore/utils/lib/findComponent";
import oe from "@semcore/utils/lib/logger";
import ae from "@semcore/utils/lib/enhances/resolveColorEnhance";
import le from "@semcore/utils/lib/addonTextChildren";
import D from "./InputSearch.mjs";
import { useBox as se } from "@semcore/flex-box";
import { selectContext as de } from "./context.mjs";
import { localizedMessages as ce } from "./translations/__intergalactic-dynamic-locales.mjs";
import { isInputTriggerTag as _e } from "@semcore/popper";
import { callAllEventHandlers as N } from "@semcore/utils/lib/assignProps";
var ge = ["Children", "options", "multiselect", "value", "uid", "forcedAdvancedMode"], ue = (
  /*__reshadow_css_start__*/
  (F.insert(
    /*__inner_css_start__*/
    '.___SOptionCheckbox_r4x1n_gg_{margin-top:var(--intergalactic-spacing-05x, 2px);margin-right:var(--intergalactic-spacing-2x, 8px);margin-bottom:auto;position:relative;flex-shrink:0;width:16px;height:16px}.___SOptionCheckbox_r4x1n_gg_::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;background:var(--intergalactic-bg-primary-neutral, #ffffff);border:1px solid;border-radius:var(--intergalactic-addon-rounded, 4px);border-color:var(--intergalactic-border-primary, #c4c7cf)}.___SOptionCheckbox_r4x1n_gg_::after{content:"";position:absolute;top:0;left:0;right:0;bottom:0;margin:0 var(--intergalactic-spacing-05x, 2px);background-repeat:no-repeat;background-position:center center}.___SOptionCheckbox_r4x1n_gg_.__selected_r4x1n_gg_::after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEwIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjI1IDFMNCA1LjI1TDEuNzUgMyIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==)}.___SOptionCheckbox_r4x1n_gg_._size_l_r4x1n_gg_{width:20px;height:20px}.___SOptionCheckbox_r4x1n_gg_._size_l_r4x1n_gg_.__selected_r4x1n_gg_::after{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEyIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMSAxLjVMNC43NSA3Ljc1TDEgNCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==)}.___SOptionCheckbox_r4x1n_gg_.__indeterminate_r4x1n_gg_:before,.___SOptionCheckbox_r4x1n_gg_.__selected_r4x1n_gg_:before{background-color:var(--intergalactic-control-primary-info, #008ff8);border-color:var(--intergalactic-control-primary-info, #008ff8)}.___SOptionCheckbox_r4x1n_gg_.__theme_r4x1n_gg_:before{border-color:var(--theme_r4x1n)}.___SOptionCheckbox_r4x1n_gg_.__theme_r4x1n_gg_.__indeterminate_r4x1n_gg_:before,.___SOptionCheckbox_r4x1n_gg_.__theme_r4x1n_gg_.__selected_r4x1n_gg_:before{background-color:var(--theme_r4x1n);border-color:var(--theme_r4x1n)}.___SOptionCheckbox_r4x1n_gg_.__selected_r4x1n_gg_{background-color:var(--intergalactic-dropdown-menu-item-selected, rgba(196, 229, 254, 0.7))}@media (hover:hover){.___SOptionCheckbox_r4x1n_gg_.__selected_r4x1n_gg_:hover{background-color:var(--intergalactic-dropdown-menu-item-selected-hover, #c4e5fe)}}.___SOptionCheckbox_r4x1n_gg_.__indeterminate_r4x1n_gg_:after{background-color:#fff;background-image:none;margin:auto;border-radius:1px}.___SOptionCheckbox_r4x1n_gg_.__indeterminate_r4x1n_gg_._size_l_r4x1n_gg_:after{width:12px;height:2px}.___SOptionCheckbox_r4x1n_gg_.__indeterminate_r4x1n_gg_._size_m_r4x1n_gg_:after{width:8px;height:2px}',
    "r4x1n_gg_"
  ), {
    __SOptionCheckbox: "___SOptionCheckbox_r4x1n_gg_",
    _selected: "__selected_r4x1n_gg_",
    _size_l: "_size_l_r4x1n_gg_",
    _indeterminate: "__indeterminate_r4x1n_gg_",
    _theme: "__theme_r4x1n_gg_",
    "--theme": "--theme_r4x1n",
    _size_m: "_size_m_r4x1n_gg_"
  })
);
function E(n, l) {
  return Array.isArray(n) ? n.includes(l) : l === n;
}
function he(n) {
  return Array.isArray(n) ? n.length === 0 : n === null;
}
function $(n) {
  return n ? [] : null;
}
var O = /* @__PURE__ */ function(n) {
  U(i, n);
  var l = X(i);
  function i() {
    var o;
    Q(this, i);
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    return o = l.call.apply(l, [this].concat(t)), b(A(o), "role", "listbox"), b(A(o), "bindHandlerOptionClick", function(a, s) {
      return function(d) {
        var _ = a, u = o.asProps, c = u.value, f = u.multiselect;
        Array.isArray(c) && (c.includes(a) ? _ = c.filter(function(m) {
          return m !== a;
        }) : _ = c.concat(a)), o.handlers.value(_, d), f || (o.handlers.visible(!1), d.preventDefault());
      };
    }), b(A(o), "handlerClear", function(a) {
      var s = o.asProps.value, d = $(Array.isArray(s));
      o.handlers.value(d, a), o.handlers.visible(!1);
    }), o;
  }
  return V(i, [{
    key: "itemRef",
    value: function(e, t, r) {
      y(C(i.prototype), "itemRef", this).call(this, e, t, r);
      var a = this.asProps.highlightedIndex, s = t === a;
      s && this.scrollToNode(r);
    }
  }, {
    key: "uncontrolledProps",
    value: function() {
      var e = this;
      return h(h({}, y(C(i.prototype), "uncontrolledProps", this).call(this)), {}, {
        visible: [null, function(t) {
          if (t === !0) {
            var r = k(e.asProps.Children, [p.InputSearch.displayName], !0), a = r ? null : e.props.defaultHighlightedIndex;
            e.handlers.highlightedIndex(a), setTimeout(function() {
              var s, d, _ = (s = e.menuRef.current) === null || s === void 0 ? void 0 : s.querySelectorAll('[role="option"]'), u = (d = e.menuRef.current) === null || d === void 0 ? void 0 : d.querySelector('[aria-selected="true"]');
              if (u && _) {
                e.scrollToNode(u);
                for (var c = 0; c < _.length; c++)
                  if (_[c] === u) {
                    e.handlers.highlightedIndex(c);
                    break;
                  }
              }
            }, 30);
          }
        }],
        value: null
      });
    }
  }, {
    key: "getTriggerProps",
    value: function() {
      var e = this, t = this.asProps, r = t.disabled, a = t.visible, s = t.state, d = t.placeholder, _ = t.value, u = t.options, c = t.forwardRef, f = t.name, m = t.multiselect, x = t.getI18nText, T = t.highlightedIndex, P = t.uid, G = t.Children, Z = t.children, z = k(G, [p.Menu.displayName], !0) || !Z, j = z ? "igc-".concat(P, "-list") : "igc-".concat(P, "-popper");
      return h(h({}, y(C(i.prototype), "getTriggerProps", this).call(this)), {}, {
        onKeyDown: N(this.handlePreventCommonKeyDown.bind(this), this.handleOpenKeyDown.bind(this), this.handleArrowKeyDown.bind(this)),
        "aria-controls": a ? j : void 0,
        "aria-haspopup": z ? "listbox" : "dialog",
        "aria-disabled": r ? "true" : "false",
        "aria-activedescendant": a && T !== null && this.itemRefs[T] ? "igc-".concat(P, "-option-").concat(T) : void 0,
        empty: he(_),
        value: _,
        name: f,
        $hiddenRef: c,
        multiselect: m,
        state: s,
        placeholder: d,
        disabled: r,
        active: a,
        onClear: this.handlerClear,
        children: this.renderChildrenTrigger(_, u),
        getI18nText: x,
        onBlur: function() {
          e.asProps.visible && (e.prevHighlightedIndex = e.asProps.highlightedIndex, e.handlers.highlightedIndex(null));
        },
        onFocus: function() {
          if (e.asProps.visible) {
            var B = e.prevHighlightedIndex;
            e.handlers.highlightedIndex(B);
          }
        }
      });
    }
  }, {
    key: "getListProps",
    value: function() {
      var e = this.asProps.multiselect;
      return h(h({}, y(C(i.prototype), "getListProps", this).call(this)), {}, {
        "aria-multiselectable": e ? "true" : void 0
      });
    }
  }, {
    key: "getPopperProps",
    value: function() {
      return h(h({}, y(C(i.prototype), "getPopperProps", this).call(this)), {}, {
        onKeyDown: N(this.handlePreventCommonKeyDown.bind(this), this.handlePreventPopperKeyDown.bind(this), this.handleArrowKeyDown.bind(this))
      });
    }
  }, {
    key: "getOptionProps",
    value: function(e, t) {
      var r, a = this, s = this.asProps, d = s.value, _ = s.highlightedIndex, u = s.focusSourceRef, c = s.size, f = c === void 0 ? "m" : c, m = t === _ && u.current === "keyboard" && !e.disabled, x = (r = e.selected) !== null && r !== void 0 ? r : E(d, e.value);
      return h(h({}, y(C(i.prototype), "getItemProps", this).call(this, e, t)), {}, {
        highlighted: m,
        selected: x,
        "aria-selected": x ? "true" : "false",
        "aria-disabled": e.disabled ? "true" : "false",
        role: "option",
        onClick: this.bindHandlerOptionClick(e.value, t),
        ref: function(P) {
          return a.itemRef(e, t, P);
        },
        size: f
      });
    }
  }, {
    key: "getOptionCheckboxProps",
    value: function() {
      var e = this.asProps, t = e.size, r = e.resolveColor;
      return {
        size: t,
        resolveColor: r
      };
    }
  }, {
    key: "getDividerProps",
    value: function() {
      return {
        my: 1,
        "aria-disabled": "true"
      };
    }
  }, {
    key: "renderChildrenTrigger",
    value: function(e, t) {
      return t ? [].concat(e).reduce(function(r, a) {
        var s = t.find(function(d) {
          return E(a, d.value);
        });
        return s && (r.length && r.push(", "), r.push(s.label || s.value)), r;
      }, []) : Array.isArray(e) ? e.reduce(function(r, a) {
        return r.length && r.push(", "), r.push(a), r;
      }, []) : e;
    }
  }, {
    key: "render",
    value: function() {
      var e = this.asProps, t = this.asProps, r = t.Children, a = t.options, s = t.multiselect;
      t.value;
      var d = t.uid, _ = t.forcedAdvancedMode, u = J(t, ge), c = _ || ie(r, [p.Trigger.displayName, p.Popper.displayName]);
      if (oe.warn(a && c, "Don't use at the same time 'options' property and '<Select.Trigger/>/<Select.Popper/>'", u["data-ui-name"] || p.displayName), this.itemProps = [], a) {
        var f = this.asProps;
        return /* @__PURE__ */ g.createElement(v, S({}, f), /* @__PURE__ */ g.createElement(p.Trigger, u), /* @__PURE__ */ g.createElement(p.Menu, null, a.map(function(m, x) {
          return /* @__PURE__ */ g.createElement(p.Option, M({
            key: m.value,
            id: "igc-".concat(d, "-option-").concat(x)
          }, m), s && /* @__PURE__ */ g.createElement(p.Option.Checkbox, null), m.children);
        })));
      }
      return /* @__PURE__ */ g.createElement(v, S({}, e), /* @__PURE__ */ g.createElement(r, null));
    }
  }]), i;
}(re);
b(O, "displayName", "Select");
b(O, "style", ue);
b(O, "enhance", Object.values(ee).concat([ae()]));
b(O, "defaultProps", function(n) {
  var l, i, o, e, t = n.children && k(n.children, [p.InputSearch.displayName], !0), r = t ? null : 0;
  return {
    placeholder: n.multiselect ? "Select options" : "Select option",
    size: "m",
    defaultValue: $(n.multiselect),
    defaultVisible: !1,
    defaultHighlightedIndex: (l = n.highlightedIndex) !== null && l !== void 0 ? l : r,
    defaultSelectedIndex: (i = n.selectedIndex) !== null && i !== void 0 ? i : r,
    scrollToSelected: !0,
    i18n: ce,
    locale: "en",
    interaction: (o = n.interaction) !== null && o !== void 0 ? o : "click",
    inlineActions: !1,
    timeout: (e = n.timeout) !== null && e !== void 0 ? e : 0
  };
});
function pe(n) {
  var l = arguments[0], i, o = n.Children, e = n.name, t = n.value, r = n.styles, a = n.$hiddenRef, s = n.tag, d = s === void 0 ? I : s, _ = n.getI18nText, u = _e(d), c = w.Trigger;
  return i = R(r), /* @__PURE__ */ g.createElement(c, i.cn("SSelectTrigger", h({}, S({
    tag: d,
    placeholder: _("selectPlaceholder"),
    role: "combobox",
    "aria-autocomplete": u && "list" || void 0
  }, l))), le(o, d.Text || I.Text, d.Value || I.Text, d.Addon || I.Addon, !0), e && /* @__PURE__ */ g.createElement("input", i.cn("input", {
    type: "hidden",
    defaultValue: t,
    name: e,
    ref: a
  })));
}
var L = /* @__PURE__ */ g.createContext({});
function me(n) {
  var l = arguments[0], i, o = w.Item, e = n.styles, t = n.Children, r = k(t, [p.Option.Checkbox.displayName]), a = k(t, [p.Option.Content.displayName]);
  return i = R(e), /* @__PURE__ */ g.createElement(o, i.cn("SSelectOption", h({}, S({}, l))), /* @__PURE__ */ g.createElement(L.Provider, {
    value: n
  }, r && !a ? /* @__PURE__ */ g.createElement(p.Option.Content, null, /* @__PURE__ */ g.createElement(t, i.cn("Children", {}))) : /* @__PURE__ */ g.createElement(t, i.cn("Children", {}))));
}
function fe(n) {
  var l = g.useContext(L), i = g.useMemo(function() {
    return h({
      selected: l == null ? void 0 : l.selected,
      disabled: l == null ? void 0 : l.disabled,
      size: l == null ? void 0 : l.size
    }, n || {});
  }, [n, l]), o = se(i, i.forwardRef), e = K(o, 2), t = e[0], r = e[1], a = i.size, s = i.theme, d = i.selected, _ = i.resolveColor, u = i.indeterminate, c = R(i.styles), f = c.cn("SOptionCheckbox", {
    size: a,
    "use:theme": _(s),
    indeterminate: u,
    selected: d
  }), m = f.className, x = f.style;
  return /* @__PURE__ */ g.createElement(t, M({}, r, {
    className: Y(m, r.className) || void 0,
    style: h(h({}, x), r.style),
    tabIndex: -1
  }));
}
var H = function() {
  var l = arguments[0];
  return /* @__PURE__ */ g.createElement(D, S({}, l));
}, p = q(O, {
  Trigger: [pe, {
    Addon: I.Addon,
    Text: I.Text
  }],
  Popper: w.Popper,
  List: v.List,
  Menu: v.Menu,
  Option: [me, {
    Addon: v.Item.Addon,
    Content: v.Item.Content,
    Hint: v.Item.Hint,
    Checkbox: fe
  }],
  Group: w.Group,
  OptionTitle: v.ItemTitle,
  OptionHint: v.ItemHint,
  Divider: ne,
  InputSearch: [H, D._______childrenComponents],
  Input: [H, D._______childrenComponents]
}, {
  parent: v,
  context: de
}), Ve = function(l) {
  return l;
};
p.selectedIndexContext = te;
export {
  p as default,
  Ve as wrapSelect
};
